import React from "react";
import { FormattedMessage } from "react-intl";
import { ItemListForFileAttachments } from "../../../reusable/ItemList/ItemListForFileAttachments";
import { Popup, PopupContent, PopupTitle } from "../../notify/Popup";

const msgKey = "imageGallery";

export const ImageUploadProgress = ({ uploadQueue }) => {
    if (!uploadQueue) return null;

    const entries = Object.values(uploadQueue);

    const files = entries.map(({ file }, index) => ({
        id: index,
        url: null,
        type: file.type,
        filename: file.name,
        fileSize: file.size
    }));

    return (
        <Popup>
            <PopupTitle icon="upload">
                <FormattedMessage id={`${msgKey}.uploading`} />
            </PopupTitle>
            <PopupContent>
                <ItemListForFileAttachments files={files} uploadQueue={uploadQueue} />
            </PopupContent>
        </Popup>
    );
};
